import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export default class BrandSubscription {
    key: string;
    subscription: string;
    created: Date;
    finished: Date;
    payed?: Date;
    price: number;
    duration: number;
    valid: boolean;
    trial: boolean;

    constructor(
        key: string,
        subscription: string,
        created: Date,
        finished: Date,
        price: number,
        duration: number,
        valid: boolean,
        trial: boolean,
        payed?: Date
    ) {
        this.key = key;
        this.subscription = subscription;
        this.created = created;
        this.finished = finished;
        this.price = price;
        this.duration = duration;
        this.valid = valid;
        this.trial = trial;
        this.payed = payed;
    }

    public static readonly info = async (uuid: string, brand: string) =>
        (await axios
            .get(environment.api_url + "/" + brand + "/subscription", {
                headers: {
                    "User-Token": uuid,
                },
            })
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as BrandSubscription | undefined;

    public static readonly register = async (
        uuid: string,
        brand: string,
        subscription: string,
        promocode?: string
    ) =>
        (
            await axios
                .post(
                    environment.api_url + "/" + brand + "/subscription/",
                    {
                        subscription,
                        promocode,
                    },
                    {
                        headers: {
                            "User-Token": uuid,
                        },
                    }
                )
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        ).key as string | undefined;
}
